import { render, staticRenderFns } from "./TotalPrice.vue?vue&type=template&id=2fc86a50&scoped=true"
import script from "./TotalPrice.vue?vue&type=script&lang=js"
export * from "./TotalPrice.vue?vue&type=script&lang=js"
import style0 from "./TotalPrice.vue?vue&type=style&index=0&id=2fc86a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc86a50",
  null
  
)

export default component.exports